import React, { useEffect, useState } from "react";
import Navbar from "../../components/common/Navbar";
import BannerSection from "../../components/common/BannerSection";
import ContactBanner from "../../assets/images/background-img.png";
import "../../assets/styles/contact.css";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { config } from "../config";
import Slider from "react-slick";
import moment from "moment";
const Product = () => {
       const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        axios
            // .get("http://localhost/elementeers_crm/api/product_category")
            .get("https://admin.elementeers.com/api/product_category")
            .then((response) => {
                setData(response.data.product_category);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, []);

    let specifications = [];
    try {
        specifications = JSON.parse(data.specifications);
    } catch (e) {
        console.error("Error parsing specifications:", e);
    }
    useEffect(() => window.scrollTo(0, 0), [])
  
    return (
        <div>
            <Helmet>
                <title>Products - Elementeers Nucleons</title>
            </Helmet>
            <Navbar inner={true} />
            <BannerSection
                Banner={ContactBanner}
                title="Products"
                subtitle=""
            />
            <div className="">
                <div className="contact-info-area pb-80 pt-80">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="row">
                        {data.map((item) => (
                            <div
                                className="col-lg-3 col-md-6"
                            >
                                <div className="single-features">
                                    <Link
                                        to={`${config.appUrl}${item.slug}`}
                                        className=""
                                    >
                                        <img  src={`${config.imageUrl}/product/categories/${item.image}`} width={316} />
                                        <h3>
                                            <span className="feature-id">
                                               {item.name}
                                            </span>
                                        </h3>
                                    </Link>
                                </div>
                            </div>
                         ))}
                    </div>
                     {/* <div className="text-center">
                        <button className="category-product">View All <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="black" stroke-width="2">
                            <polyline points="6 4 12 10 6 16" stroke-linecap="round" stroke-linejoin="round" />
                            <polyline points="12 4 18 10 12 16" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        </button>
                    </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Product;
